import styles from './loadingSpinner.module.scss';

/**
 * Loading spinner that covers the screen. Primarily used to show transactions are processing.
 * 
 * @param props - The component props.
 * @param props.active - Whether the spinner should be active or not.
 * @return Loading Spinner component.
 * 
 * @example
 * ```tsx
 * <LoadingSpinner 
 *    active={isLoading} 
 * />
 * ```
 */
const LoadingSpinner = ({
    active,
}: {
    active: boolean;
}) => {
    return (
        <>
            {active && (
                <div className={styles.loaderContainer}>
                    <div className={styles.spinner} />
                </div>
            )}
        </>
    );
};

export default LoadingSpinner;
